import { useEffect, useState } from "react";
import { Loader2, QrCode } from "lucide-react";
import { api } from "@/lib/api";

export function HandoutTracker() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/handouts").then((r) => setD(r.data)).catch(() => setD({ rows: [], totals: {} })); }, []);
  if (!d) return <Loader2 className="h-5 w-5 animate-spin text-emerald-600" />;
  const t = d.totals;
  return (
    <div className="bg-white border border-slate-200 rounded-lg mt-6" data-testid="handout-tracker">
      <div className="p-5 border-b border-slate-100 flex flex-wrap items-center gap-6">
        <div className="flex items-center gap-2"><QrCode className="h-5 w-5 text-emerald-600" /><h3 className="font-semibold text-slate-900">Handout results (QR codes)</h3></div>
        <div className="flex gap-6 text-sm ml-auto">
          {[["Scans", t.scans, "scans"], ["Sign-ups", t.signups, "signups"], ["Paying", t.paying, "paying"]].map(([l, v, id]) => <div key={id}><span className="text-slate-500">{l} </span><b className="text-slate-900" data-testid={`handout-total-${id}`}>{v ?? 0}</b></div>)}
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs text-slate-500 uppercase tracking-wider"><tr><th className="text-left px-5 py-2">Handout</th><th className="text-right px-3 py-2">Scans</th><th className="text-right px-3 py-2">Sign-ups</th><th className="text-right px-3 py-2">Paying</th><th className="text-right px-5 py-2">Scan → sign-up</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {d.rows.map((r) => (
              <tr key={r.code || "none"} data-testid={`handout-row-${r.code || "general"}`}>
                <td className="px-5 py-2.5"><div className="text-slate-900">{r.label}</div>{r.code && <code className="text-[11px] text-slate-400">{r.code}</code>}</td>
                <td className="text-right px-3">{r.scans}</td><td className="text-right px-3 font-semibold">{r.signups}</td><td className="text-right px-3">{r.paying}</td>
                <td className="text-right px-5 text-slate-600">{r.rate == null ? "—" : `${r.rate}%`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="px-5 py-3 text-xs text-slate-500 border-t border-slate-100">A scan is counted once per phone visit. Sign-ups are counted when someone creates an account within 30 days of scanning. Test accounts are excluded.</p>
    </div>
  );
}
